import { addMethod, string } from 'yup';

addMethod(string, 'department', function (message) {
  return this.test('department-test', message, (value) => {
    const regex = /^(0[1-9]|[1-8][0-9]|9[0-59]|2[ABab]|97[1-4]|98[6-8])$/;
    return regex.test(value ?? 'null');
  });
});
